import {Injectable} from '@angular/core';
import * as io from 'socket.io-client';
import * as constants from '../constants';
import {UserService} from './user.service';
import {GlobalService} from './global.service';
import {ToolsService} from './tools.service';
import {ProtocolListService} from '../state/protocol-list.service';
import {ContactListService} from '../state/contact-list.service';
import {AudioService} from './audio.service';
import {NotificationService} from './notification.service';
import {KtDialogService} from '../core/_base/layout';
import {take} from 'rxjs/operators';
import {ProtocolListQuery} from '../state/protocol-list.query';
import {Router} from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class SocketOldService {
	public socket: any = null;
	public loading: any = false;

	constructor(public user: UserService,
				public global: GlobalService,
				public tools: ToolsService,
				public protocolListService: ProtocolListService,
				public contactListService: ContactListService,
				public audio: AudioService,
				public notification: NotificationService,
				public ktDialogService: KtDialogService,
				public protocolListQuery: ProtocolListQuery,
				public router: Router) {
	}

	reset() {
		console.info('Socket::reset');

		// if (this.socket) {
		// 	this.socket.disconnect();
		// 	this.socket.destroy();
		// 	this.socket = null;
		// }

		this.protocolListService.clear();
		this.contactListService.clear();
	}

	connect() {
		const protocolsData = [
			{
				'id': 16,
				'criado_em': null,
				'finalizado_em': null,
				'deletado': 0,
				'numero': '19520217CDP8',
				'status': 'Em Espera',
				'contato_id': 14,
				'recado_id': null,
				'api_chat_id': '554797818915@c.us',
				'ultima_atualizacao': '2021-05-19T15:32:21.000Z',
				'usuario_id': null,
				'abandonado': 0,
				'created_at': '2021-05-19T15:32:21.000Z',
				'updated_at': '2021-05-19T15:32:21.000Z',
				'contato': {
					'id': 14,
					'criado_em': null,
					'last_activity': '2021-05-19T15:35:49.000Z',
					'deletado': 0,
					'nome': '+55 47 9781-8915',
					'avatar_arquivo': null,
					'avatar_url': '',
					'telefone': '554797818915',
					'celular': '554797818915',
					'whatsapp': '554797818915',
					'valido': 1,
					'descricao': null,
					'empresa': null,
					'grupo_id': null,
					'inscrito': 1,
					'cidade_id': null,
					'sexo': 'Masculino',
					'usuario_id': null,
					'bloqueado': null,
					'origem': null,
					'operadora': null,
					'email': null,
					'whatsapp_status': null,
					'canal_id': 2,
					'created_at': '2021-05-19T15:32:21.000Z',
					'updated_at': '2021-05-19T15:35:49.000Z'
				},
				'mensagens_enviadas': [],
				'mensagens_recebidas': [
					{
						'id': 52,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Você trabalhar esta sabado',
						'remetente': '554797818915@c.us',
						'api_id': 'false_554797818915@c.us_47AB703EC31CA40AE66E07EBAA9AE8F7',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 16,
						'usuario_id': null,
						'lida': 0,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T15:35:49.000Z',
						'updated_at': '2021-05-19T15:35:49.000Z'
					}
				],
				'unread_messages_count': 1,
				'last_received_message': 'Você trabalhar esta sabado',
				'mensagens': [
					{
						'id': 52,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Você trabalhar esta sabado',
						'remetente': '554797818915@c.us',
						'api_id': 'false_554797818915@c.us_47AB703EC31CA40AE66E07EBAA9AE8F7',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 16,
						'usuario_id': null,
						'lida': 0,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T15:35:49.000Z',
						'updated_at': '2021-05-19T15:35:49.000Z'
					}
				],
				'last_message': {
					'id': 52,
					'criado_em': null,
					'deletado': 0,
					'conteudo': 'Você trabalhar esta sabado',
					'remetente': '554797818915@c.us',
					'api_id': 'false_554797818915@c.us_47AB703EC31CA40AE66E07EBAA9AE8F7',
					'api_chat_id': null,
					'contato_id': null,
					'protocolo_id': 16,
					'usuario_id': null,
					'lida': 0,
					'tipo': 'chat',
					'midia_url': null,
					'dados_extras': 'null',
					'created_at': '2021-05-19T15:35:49.000Z',
					'updated_at': '2021-05-19T15:35:49.000Z'
				}
			},
			{
				'id': 15,
				'criado_em': null,
				'finalizado_em': null,
				'deletado': 0,
				'numero': '1952021AVU54',
				'status': 'Em Espera',
				'contato_id': 12,
				'recado_id': null,
				'api_chat_id': '554791060553@c.us',
				'ultima_atualizacao': '2021-05-19T12:38:10.000Z',
				'usuario_id': null,
				'abandonado': 0,
				'created_at': '2021-05-19T12:38:10.000Z',
				'updated_at': '2021-05-19T12:38:10.000Z',
				'contato': {
					'id': 12,
					'criado_em': null,
					'last_activity': '2021-05-19T12:38:52.000Z',
					'deletado': 0,
					'nome': 'Ricardo',
					'avatar_arquivo': null,
					'avatar_url': '',
					'telefone': '554791060553',
					'celular': '554791060553',
					'whatsapp': '554791060553',
					'valido': 1,
					'descricao': null,
					'empresa': null,
					'grupo_id': null,
					'inscrito': 1,
					'cidade_id': null,
					'sexo': 'Masculino',
					'usuario_id': null,
					'bloqueado': null,
					'origem': null,
					'operadora': null,
					'email': null,
					'whatsapp_status': null,
					'canal_id': 2,
					'created_at': '2021-05-19T12:38:10.000Z',
					'updated_at': '2021-05-19T12:38:52.000Z'
				},
				'mensagens_enviadas': [],
				'mensagens_recebidas': [
					{
						'id': 43,
						'criado_em': null,
						'deletado': 0,
						'conteudo': '/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCABkAFYDASIAAhEBAxEB/8QAHQAAAQUBAQEBAAAAAAAAAAAAAAMEBQYJAgEHCP/EAEYQAAIBAgUCAwMGCAwHAAAAAAECAwQRAAUGEiETMSJBUQcUkRYjMmGB0QhSU3F0kpOhFRgkNUJEVnKCssHTNlRVs9Lh8P/EABoBAAIDAQEAAAAAAAAAAAAAAAADAgQFAQb/xAAyEQABAwICBwcEAgMAAAAAAAABAAIRAyESMQRBUWFxgaEFExQikbHwIzLB4QYkM0LR/9oADAMBAAIRAxEAPwD8p0v4PuuKbJqzKGg0dO9WQVrZZKk1EFmRvm2ChRwjLyp4kfz2ld09GZxTUej8io5YpS8GW0sbFQLErEoNufqxl9FLWe5TRwxfMcdZxEDa5uAXtcC6ji9uMaM/wdQppHJdRyaNbPqqgEMiiGKNp6dFpZA0kW5WZpNkksSKtixnKkqrOw9D2s6m2m19XIfNSKFJ1Wp3dPM7497K9Jq3KHqGpEkLTpfdEGQuLBSbjdfgOh/xr6jC3yho/wAjP8F+/ETLpjKtMZFKNP6aqZ0pYgsOWZatLC0gjQIiRiRo4h4ERV3MoACi4A4lvk9R/lp/iv3YyP6+9cuj5Q0f5Gf4L9+D5Q0f5Gf4L9+InPoFyfKK/MqTL63MpqRlEdLB9OW+30UnjcSSB2GGs1X0jTGPSGp5o6mOKQyIlMOkHW53q0gcFOAy7SbngMASGdzSwCpBgmOdj+UsVWmoaeuJ5e2pWD5Q0f5Gf4L9+D5Q0f5Gf4L9+GzZblyDxnMAQLkCFmtxe11Ug/Z58YDl2WC3izDm/wDV3/8ADEMNDemXS759SsyMoqUCNcgKlnFiLG57cg8WNwPK4PdRWyzBRHDmcFjcmOFDfg8HcD6g/YPru3XLMtaQxh6+4cJcwsBfnz2Wtwee3b1GHv8ABh/6jW/tf/WIu7oZLlyoKgFTlepM4zitzTMp6fNI6YQUEqER0hjDhmS7kDeGS9lHKX5vwYdZzSCmaJuvNKXDAmRrkAW+/Bh7KFOo0OXSSsrRNKIjAJXEZO4puO0n1t641L0HPFDpfLhJURR7oENnNiwEKE258u5xlossiK6I7Ksg2uAbbhe9j6i4B/OB6Y0+0tT0FRpHLxU0OW1c0dMhiSsZQATEnmVYgEgAkDy87Wxc7bNUUAaDQ52oEkDVrAd7f9XKeHF5svnBW6nrqKreSOkrIJni2mRY5AxTcLrcDtccj1GGOXZ1QtlkM9ZqDKqqRI2E9TTsI4XdNwkKqXfYAySAgsxXaQTwceZQaSjg2GkymgLojOlHMGXqW8QvsS4B4Btcjmy9seFMuW5Shyi4c7byqPD5H6HB+r9+POjxOFpLBOvzGBwOG/oEzySb9P2n8O7qVO0gHqixIv8A0Fw4wyiqqMvUh6iEq8nYuLEbFGFvfaP/AJuH9oMWXNdOSglWJFgAeTbt2x6L2574QNZSEi1bCLHnxjnB71QXDe809xex3jz745hdsXZTjBhD32iHAq4P2gxXc9odSZhWifJPaHBlVOECmD3CGe7XPi3Mb9iBb6sMpUe8dhc4N3mfwCeiVWqOpNxNaXHYInqQOqf6i/q/+P8A0wYbZiziioIJ8wStqIotk06qq9RwFBfaOFuQTYdsGL9AYWAfM1IGRKyt3HaV4sSD2F/j9uNO8hh1FU6LyuHTeYU1HMwhE000RkKRdJblBYgsDbg2B9RjMoVcoo2oQE6TSCUnYNxYCw8XewBPHbk41H0JHK+lsu6czIOjFu227dJPUG/NvTucWe2m46IbflYqMYrJnX6f9plXmFc9P7S6Ohy+epklpIoNOq09NE1JJEsRlklZZNs7RVG7pgkxsh8D2W5bx6N+qceRI6Ah5WkJ82tx8AMJrBKCAZ5NvJPiB5J7du2MEmdSao3OY84qMtr4dP1SU1e0sfSlkHhUDplr3RwLqGH0T3+3DzLqespaYR12aTV05VN8rQrGNwRVYqqqLAspexLEFyAbAAcVdAuZ01dQtVVNMJnA6tNKYpU8KG6sOQeP9DhxTUYpU6aVNQ460kxMsm8nezNtu1yFBbwgWsFUdhbDHVCW93AjOdeWU5wI6pYZ9Qvk5RnbXq270ol0LFpJH3G4DL9EegsBx+fHW8ejfqnHLwI8qTFpAyKVAEjBbEg8qDYnwjki45A4Jv7FEsKhELkAAeJyx4+sn9+Fpi93j0b9U4N49G/VOCONY12qWP8AeYsf34pOq5NaPTVOm8h0rXyUapEkGZwZ6kNQbBWJvIGfuCpJJLC/POLGjUPEVMAIG8kC3MieGar6TpA0amXkE7AATfkDHHJT2oWB93tf+n3FvTBiuUddqiSKly7PtMTZfFSwbI6mbM46qSdgFF22gHcQLk+ZwY0W0jRGAkHgQR6gkIo1hXYHgEcQQfQgFZl9QNTiFpWsjF1XYLXNgeb37KuNDaT2wUejFyvSEWjtSZ9mEuUwZkUyikFRshIEd2G4MLMvJtbxDnnGb6as0etO4OpMu6zcAe9QlbXBvcm4PHl8e4xoQcr9p0WYZdqPQNfkHuVVkmXwTwZjNUJvlgd5Y3BgAYqBIRtL7WDMGVhbF3TmtqNAN1qdmU6FSsRpERBzMCePzkuP45ns+/s1qH9nB/uYP45ns+/s1qH9nB/uY+a0H4OftLy+kqaCDMNKtT1saxVMbz1LCUK6upPzfhYFeCtjYsOxIx7qb8Hz2u6wzup1HqPU2nqzMavZ1pupJHu2oEXwpAFFlUDgeWKXhdHnLqV7kdn/AMXxwaow7cZnVFsPHXaBnNv09oLVmV+0rSceqcupqqno8xlcpHMQsq9NthvsJA8SE8Hti1Y+Z+yvSq6J9klNpfV1bQbKOSYVMy1TRQWeYuvzhCkfTUeXNxz53WkyLK6f3mXLoOl71VtVT9CrkRXnuQzEKbXJHiHYm9wbYxajMOlPgACBBm5u6xEWA1GTJLrCJPhtNZSZWeKBJYHODdkA2vrMRPLapfHIUBy9zcgDubcX8u3niLzHT+T5rBFRZpllNViGJ44jPIXlVCu1rOfHyNoY3ub8381ssymiyeOSHK6GGBJXMjhXPie1rm478C/2/bOBCpqQw3rqNa+lekaeeEPa0kMhR1IIIII+scg3BFwQQSMNqbKYaQjoLOqgIoU10zKAnayk2H1+vnfEXNp3SmV6eky6rp6WmyT5tnSaudYEtKHWxY2W7m/Ft3AN+2J0wMYgnMZCT6Tns2pdX/G7LI5mBzOob0vnNOtLTUNKkkjrDGYw0jl3YAKLsx5J9Se+DCFZFRwZZlkGWiL3KKAJTGKUyKYgqhbMe4taxub98GNGj9nr7ob9oWHLP7QG0bHoUaer1ypMzfNmUUEm+SoaJYgWYjsqqbAW5dr38Ntqcgq6mvyLLa6sAFRU0kMsoC28bIC3HlyTjM0smwKE8Xm1/wD7jtjTHT38wZb+hw/5Bi/pTC2JMqLGtZOERN1IYMGDFVTUlFV5XQ6eq6rOlVqFH+eDQmUbTtHKAEkXI8vrxYAACbAc8n68QFPnGXZBkNTm2bVHQpIJR1JNjPbcVUcKCTyQO2JqnqY6nqdNZR0pGibqRPHcjuRuA3D0YXB8jjGrH6zhOzjr6bOabheGBxHlvGyRE+4nklsGEKishpXjSRJ2MhsOnA8gHIHJUEL9Id7cXPYG3MVfBNVyUSJUCSIbmZqaRYz+ZyoVu/YE4jCilBS0wd5BTxb5CpdtguxX6Nz528vTDDPpMgocpqajPaaBqFnQzq9N1g7l1VLoASx3bLcHsPTDyirYa+IzQJUKobbaankha/8AdcA2572thHMc6y3KcsbOMyqDTUibN0kkbDbvYKt1tccsByOPO2G0g41GgAkyLDPlnfZYpdYgU3EkAQbnLnlbbcKKr5qCoyzLJ8qCCikgD0wRNiiIqpSy2G0WtxYWwY7zWspsxosvzCjk6lPVRdaJ7EbkYKVNjyOCO+DGjRs2+/PPNDILRHTLksr/AHn+Se6dCG28ydTZ85cgC270Fjx28R+q2lunv5gy39Dh/wAgxmZjTPT38wZb+hw/5BjT0z/VAUhgwYMUV1T2RFloXKJuPWta9uLLc/YOcL5dV5lUzVyZhlPucdPULHSv11k95iMMbmSw+haR5I9p5PS3dmGKyQD3AODav4o+GKr9Gxkmc/m1dlW5pJw9lpty3tfeBxxz+9v1frwtil7V/FHwwbV/FHwxDwe/p+0SrphtJVzpO0S5ZUuqrcSq0e1ja9hdwb+XIGKptX8UfDBtX8UfDB4Pf0/aJUxnzM8dK7RtGWDEo1rqfDwbEi/5icGIkrGoujMSTexQDaNo4vc38W4344IFuLkxZpMwMDVyZWXeNZNM/wDDmVfoMH/bXBgw3tjJnP8ACGqSwYMGMNTRgwYMCEYMGDAhGDBgwIRgwYMCF//Z',
						'remetente': '554791060553@c.us',
						'api_id': 'false_554791060553@c.us_3EB06ECB75FB0640A07F',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 15,
						'usuario_id': null,
						'lida': 0,
						'tipo': 'image',
						'midia_url': 'medias/554791060553@c.us/140081028918672.jpe',
						'dados_extras': '{"mime":"image/jpeg","size":132700,"caption":null}',
						'created_at': '2021-05-19T12:38:52.000Z',
						'updated_at': '2021-05-19T12:38:52.000Z'
					}
				],
				'unread_messages_count': 1,
				'last_received_message': '/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCABkAFYDASIAAhEBAxEB/8QAHQAAAQUBAQEBAAAAAAAAAAAAAAMEBQYJAgEHCP/EAEYQAAIBAgUCAwMGCAwHAAAAAAECAwQRAAUGEiETMSJBUQcUkRYjMmGB0QhSU3F0kpOhFRgkNUJEVnKCssHTNlRVs9Lh8P/EABoBAAIDAQEAAAAAAAAAAAAAAAADAgQFAQb/xAAyEQABAwICBwcEAgMAAAAAAAABAAIRAyESMQRBUWFxgaEFExQikbHwIzLB4QYkM0LR/9oADAMBAAIRAxEAPwD8p0v4PuuKbJqzKGg0dO9WQVrZZKk1EFmRvm2ChRwjLyp4kfz2ld09GZxTUej8io5YpS8GW0sbFQLErEoNufqxl9FLWe5TRwxfMcdZxEDa5uAXtcC6ji9uMaM/wdQppHJdRyaNbPqqgEMiiGKNp6dFpZA0kW5WZpNkksSKtixnKkqrOw9D2s6m2m19XIfNSKFJ1Wp3dPM7497K9Jq3KHqGpEkLTpfdEGQuLBSbjdfgOh/xr6jC3yho/wAjP8F+/ETLpjKtMZFKNP6aqZ0pYgsOWZatLC0gjQIiRiRo4h4ERV3MoACi4A4lvk9R/lp/iv3YyP6+9cuj5Q0f5Gf4L9+D5Q0f5Gf4L9+InPoFyfKK/MqTL63MpqRlEdLB9OW+30UnjcSSB2GGs1X0jTGPSGp5o6mOKQyIlMOkHW53q0gcFOAy7SbngMASGdzSwCpBgmOdj+UsVWmoaeuJ5e2pWD5Q0f5Gf4L9+D5Q0f5Gf4L9+GzZblyDxnMAQLkCFmtxe11Ug/Z58YDl2WC3izDm/wDV3/8ADEMNDemXS759SsyMoqUCNcgKlnFiLG57cg8WNwPK4PdRWyzBRHDmcFjcmOFDfg8HcD6g/YPru3XLMtaQxh6+4cJcwsBfnz2Wtwee3b1GHv8ABh/6jW/tf/WIu7oZLlyoKgFTlepM4zitzTMp6fNI6YQUEqER0hjDhmS7kDeGS9lHKX5vwYdZzSCmaJuvNKXDAmRrkAW+/Bh7KFOo0OXSSsrRNKIjAJXEZO4puO0n1t641L0HPFDpfLhJURR7oENnNiwEKE258u5xlossiK6I7Ksg2uAbbhe9j6i4B/OB6Y0+0tT0FRpHLxU0OW1c0dMhiSsZQATEnmVYgEgAkDy87Wxc7bNUUAaDQ52oEkDVrAd7f9XKeHF5svnBW6nrqKreSOkrIJni2mRY5AxTcLrcDtccj1GGOXZ1QtlkM9ZqDKqqRI2E9TTsI4XdNwkKqXfYAySAgsxXaQTwceZQaSjg2GkymgLojOlHMGXqW8QvsS4B4Btcjmy9seFMuW5Shyi4c7byqPD5H6HB+r9+POjxOFpLBOvzGBwOG/oEzySb9P2n8O7qVO0gHqixIv8A0Fw4wyiqqMvUh6iEq8nYuLEbFGFvfaP/AJuH9oMWXNdOSglWJFgAeTbt2x6L2574QNZSEi1bCLHnxjnB71QXDe809xex3jz745hdsXZTjBhD32iHAq4P2gxXc9odSZhWifJPaHBlVOECmD3CGe7XPi3Mb9iBb6sMpUe8dhc4N3mfwCeiVWqOpNxNaXHYInqQOqf6i/q/+P8A0wYbZiziioIJ8wStqIotk06qq9RwFBfaOFuQTYdsGL9AYWAfM1IGRKyt3HaV4sSD2F/j9uNO8hh1FU6LyuHTeYU1HMwhE000RkKRdJblBYgsDbg2B9RjMoVcoo2oQE6TSCUnYNxYCw8XewBPHbk41H0JHK+lsu6czIOjFu227dJPUG/NvTucWe2m46IbflYqMYrJnX6f9plXmFc9P7S6Ohy+epklpIoNOq09NE1JJEsRlklZZNs7RVG7pgkxsh8D2W5bx6N+qceRI6Ah5WkJ82tx8AMJrBKCAZ5NvJPiB5J7du2MEmdSao3OY84qMtr4dP1SU1e0sfSlkHhUDplr3RwLqGH0T3+3DzLqespaYR12aTV05VN8rQrGNwRVYqqqLAspexLEFyAbAAcVdAuZ01dQtVVNMJnA6tNKYpU8KG6sOQeP9DhxTUYpU6aVNQ460kxMsm8nezNtu1yFBbwgWsFUdhbDHVCW93AjOdeWU5wI6pYZ9Qvk5RnbXq270ol0LFpJH3G4DL9EegsBx+fHW8ejfqnHLwI8qTFpAyKVAEjBbEg8qDYnwjki45A4Jv7FEsKhELkAAeJyx4+sn9+Fpi93j0b9U4N49G/VOCONY12qWP8AeYsf34pOq5NaPTVOm8h0rXyUapEkGZwZ6kNQbBWJvIGfuCpJJLC/POLGjUPEVMAIG8kC3MieGar6TpA0amXkE7AATfkDHHJT2oWB93tf+n3FvTBiuUddqiSKly7PtMTZfFSwbI6mbM46qSdgFF22gHcQLk+ZwY0W0jRGAkHgQR6gkIo1hXYHgEcQQfQgFZl9QNTiFpWsjF1XYLXNgeb37KuNDaT2wUejFyvSEWjtSZ9mEuUwZkUyikFRshIEd2G4MLMvJtbxDnnGb6as0etO4OpMu6zcAe9QlbXBvcm4PHl8e4xoQcr9p0WYZdqPQNfkHuVVkmXwTwZjNUJvlgd5Y3BgAYqBIRtL7WDMGVhbF3TmtqNAN1qdmU6FSsRpERBzMCePzkuP45ns+/s1qH9nB/uYP45ns+/s1qH9nB/uY+a0H4OftLy+kqaCDMNKtT1saxVMbz1LCUK6upPzfhYFeCtjYsOxIx7qb8Hz2u6wzup1HqPU2nqzMavZ1pupJHu2oEXwpAFFlUDgeWKXhdHnLqV7kdn/AMXxwaow7cZnVFsPHXaBnNv09oLVmV+0rSceqcupqqno8xlcpHMQsq9NthvsJA8SE8Hti1Y+Z+yvSq6J9klNpfV1bQbKOSYVMy1TRQWeYuvzhCkfTUeXNxz53WkyLK6f3mXLoOl71VtVT9CrkRXnuQzEKbXJHiHYm9wbYxajMOlPgACBBm5u6xEWA1GTJLrCJPhtNZSZWeKBJYHODdkA2vrMRPLapfHIUBy9zcgDubcX8u3niLzHT+T5rBFRZpllNViGJ44jPIXlVCu1rOfHyNoY3ub8381ssymiyeOSHK6GGBJXMjhXPie1rm478C/2/bOBCpqQw3rqNa+lekaeeEPa0kMhR1IIIII+scg3BFwQQSMNqbKYaQjoLOqgIoU10zKAnayk2H1+vnfEXNp3SmV6eky6rp6WmyT5tnSaudYEtKHWxY2W7m/Ft3AN+2J0wMYgnMZCT6Tns2pdX/G7LI5mBzOob0vnNOtLTUNKkkjrDGYw0jl3YAKLsx5J9Se+DCFZFRwZZlkGWiL3KKAJTGKUyKYgqhbMe4taxub98GNGj9nr7ob9oWHLP7QG0bHoUaer1ypMzfNmUUEm+SoaJYgWYjsqqbAW5dr38Ntqcgq6mvyLLa6sAFRU0kMsoC28bIC3HlyTjM0smwKE8Xm1/wD7jtjTHT38wZb+hw/5Bi/pTC2JMqLGtZOERN1IYMGDFVTUlFV5XQ6eq6rOlVqFH+eDQmUbTtHKAEkXI8vrxYAACbAc8n68QFPnGXZBkNTm2bVHQpIJR1JNjPbcVUcKCTyQO2JqnqY6nqdNZR0pGibqRPHcjuRuA3D0YXB8jjGrH6zhOzjr6bOabheGBxHlvGyRE+4nklsGEKishpXjSRJ2MhsOnA8gHIHJUEL9Id7cXPYG3MVfBNVyUSJUCSIbmZqaRYz+ZyoVu/YE4jCilBS0wd5BTxb5CpdtguxX6Nz528vTDDPpMgocpqajPaaBqFnQzq9N1g7l1VLoASx3bLcHsPTDyirYa+IzQJUKobbaankha/8AdcA2572thHMc6y3KcsbOMyqDTUibN0kkbDbvYKt1tccsByOPO2G0g41GgAkyLDPlnfZYpdYgU3EkAQbnLnlbbcKKr5qCoyzLJ8qCCikgD0wRNiiIqpSy2G0WtxYWwY7zWspsxosvzCjk6lPVRdaJ7EbkYKVNjyOCO+DGjRs2+/PPNDILRHTLksr/AHn+Se6dCG28ydTZ85cgC270Fjx28R+q2lunv5gy39Dh/wAgxmZjTPT38wZb+hw/5BjT0z/VAUhgwYMUV1T2RFloXKJuPWta9uLLc/YOcL5dV5lUzVyZhlPucdPULHSv11k95iMMbmSw+haR5I9p5PS3dmGKyQD3AODav4o+GKr9Gxkmc/m1dlW5pJw9lpty3tfeBxxz+9v1frwtil7V/FHwwbV/FHwxDwe/p+0SrphtJVzpO0S5ZUuqrcSq0e1ja9hdwb+XIGKptX8UfDBtX8UfDB4Pf0/aJUxnzM8dK7RtGWDEo1rqfDwbEi/5icGIkrGoujMSTexQDaNo4vc38W4344IFuLkxZpMwMDVyZWXeNZNM/wDDmVfoMH/bXBgw3tjJnP8ACGqSwYMGMNTRgwYMCEYMGDAhGDBgwIRgwYMCF//Z',
				'mensagens': [
					{
						'id': 43,
						'criado_em': null,
						'deletado': 0,
						'conteudo': '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',
						'remetente': '554791060553@c.us',
						'api_id': 'false_554791060553@c.us_3EB06ECB75FB0640A07F',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 15,
						'usuario_id': null,
						'lida': 0,
						'tipo': 'image',
						'midia_url': 'medias/554791060553@c.us/140081028918672.jpe',
						'dados_extras': '{"mime":"image/jpeg","size":132700,"caption":null}',
						'created_at': '2021-05-19T12:38:52.000Z',
						'updated_at': '2021-05-19T12:38:52.000Z'
					}
				],
				'last_message': {
					'id': 43,
					'criado_em': null,
					'deletado': 0,
					'conteudo': '/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCABkAFYDASIAAhEBAxEB/8QAHQAAAQUBAQEBAAAAAAAAAAAAAAMEBQYJAgEHCP/EAEYQAAIBAgUCAwMGCAwHAAAAAAECAwQRAAUGEiETMSJBUQcUkRYjMmGB0QhSU3F0kpOhFRgkNUJEVnKCssHTNlRVs9Lh8P/EABoBAAIDAQEAAAAAAAAAAAAAAAADAgQFAQb/xAAyEQABAwICBwcEAgMAAAAAAAABAAIRAyESMQRBUWFxgaEFExQikbHwIzLB4QYkM0LR/9oADAMBAAIRAxEAPwD8p0v4PuuKbJqzKGg0dO9WQVrZZKk1EFmRvm2ChRwjLyp4kfz2ld09GZxTUej8io5YpS8GW0sbFQLErEoNufqxl9FLWe5TRwxfMcdZxEDa5uAXtcC6ji9uMaM/wdQppHJdRyaNbPqqgEMiiGKNp6dFpZA0kW5WZpNkksSKtixnKkqrOw9D2s6m2m19XIfNSKFJ1Wp3dPM7497K9Jq3KHqGpEkLTpfdEGQuLBSbjdfgOh/xr6jC3yho/wAjP8F+/ETLpjKtMZFKNP6aqZ0pYgsOWZatLC0gjQIiRiRo4h4ERV3MoACi4A4lvk9R/lp/iv3YyP6+9cuj5Q0f5Gf4L9+D5Q0f5Gf4L9+InPoFyfKK/MqTL63MpqRlEdLB9OW+30UnjcSSB2GGs1X0jTGPSGp5o6mOKQyIlMOkHW53q0gcFOAy7SbngMASGdzSwCpBgmOdj+UsVWmoaeuJ5e2pWD5Q0f5Gf4L9+D5Q0f5Gf4L9+GzZblyDxnMAQLkCFmtxe11Ug/Z58YDl2WC3izDm/wDV3/8ADEMNDemXS759SsyMoqUCNcgKlnFiLG57cg8WNwPK4PdRWyzBRHDmcFjcmOFDfg8HcD6g/YPru3XLMtaQxh6+4cJcwsBfnz2Wtwee3b1GHv8ABh/6jW/tf/WIu7oZLlyoKgFTlepM4zitzTMp6fNI6YQUEqER0hjDhmS7kDeGS9lHKX5vwYdZzSCmaJuvNKXDAmRrkAW+/Bh7KFOo0OXSSsrRNKIjAJXEZO4puO0n1t641L0HPFDpfLhJURR7oENnNiwEKE258u5xlossiK6I7Ksg2uAbbhe9j6i4B/OB6Y0+0tT0FRpHLxU0OW1c0dMhiSsZQATEnmVYgEgAkDy87Wxc7bNUUAaDQ52oEkDVrAd7f9XKeHF5svnBW6nrqKreSOkrIJni2mRY5AxTcLrcDtccj1GGOXZ1QtlkM9ZqDKqqRI2E9TTsI4XdNwkKqXfYAySAgsxXaQTwceZQaSjg2GkymgLojOlHMGXqW8QvsS4B4Btcjmy9seFMuW5Shyi4c7byqPD5H6HB+r9+POjxOFpLBOvzGBwOG/oEzySb9P2n8O7qVO0gHqixIv8A0Fw4wyiqqMvUh6iEq8nYuLEbFGFvfaP/AJuH9oMWXNdOSglWJFgAeTbt2x6L2574QNZSEi1bCLHnxjnB71QXDe809xex3jz745hdsXZTjBhD32iHAq4P2gxXc9odSZhWifJPaHBlVOECmD3CGe7XPi3Mb9iBb6sMpUe8dhc4N3mfwCeiVWqOpNxNaXHYInqQOqf6i/q/+P8A0wYbZiziioIJ8wStqIotk06qq9RwFBfaOFuQTYdsGL9AYWAfM1IGRKyt3HaV4sSD2F/j9uNO8hh1FU6LyuHTeYU1HMwhE000RkKRdJblBYgsDbg2B9RjMoVcoo2oQE6TSCUnYNxYCw8XewBPHbk41H0JHK+lsu6czIOjFu227dJPUG/NvTucWe2m46IbflYqMYrJnX6f9plXmFc9P7S6Ohy+epklpIoNOq09NE1JJEsRlklZZNs7RVG7pgkxsh8D2W5bx6N+qceRI6Ah5WkJ82tx8AMJrBKCAZ5NvJPiB5J7du2MEmdSao3OY84qMtr4dP1SU1e0sfSlkHhUDplr3RwLqGH0T3+3DzLqespaYR12aTV05VN8rQrGNwRVYqqqLAspexLEFyAbAAcVdAuZ01dQtVVNMJnA6tNKYpU8KG6sOQeP9DhxTUYpU6aVNQ460kxMsm8nezNtu1yFBbwgWsFUdhbDHVCW93AjOdeWU5wI6pYZ9Qvk5RnbXq270ol0LFpJH3G4DL9EegsBx+fHW8ejfqnHLwI8qTFpAyKVAEjBbEg8qDYnwjki45A4Jv7FEsKhELkAAeJyx4+sn9+Fpi93j0b9U4N49G/VOCONY12qWP8AeYsf34pOq5NaPTVOm8h0rXyUapEkGZwZ6kNQbBWJvIGfuCpJJLC/POLGjUPEVMAIG8kC3MieGar6TpA0amXkE7AATfkDHHJT2oWB93tf+n3FvTBiuUddqiSKly7PtMTZfFSwbI6mbM46qSdgFF22gHcQLk+ZwY0W0jRGAkHgQR6gkIo1hXYHgEcQQfQgFZl9QNTiFpWsjF1XYLXNgeb37KuNDaT2wUejFyvSEWjtSZ9mEuUwZkUyikFRshIEd2G4MLMvJtbxDnnGb6as0etO4OpMu6zcAe9QlbXBvcm4PHl8e4xoQcr9p0WYZdqPQNfkHuVVkmXwTwZjNUJvlgd5Y3BgAYqBIRtL7WDMGVhbF3TmtqNAN1qdmU6FSsRpERBzMCePzkuP45ns+/s1qH9nB/uYP45ns+/s1qH9nB/uY+a0H4OftLy+kqaCDMNKtT1saxVMbz1LCUK6upPzfhYFeCtjYsOxIx7qb8Hz2u6wzup1HqPU2nqzMavZ1pupJHu2oEXwpAFFlUDgeWKXhdHnLqV7kdn/AMXxwaow7cZnVFsPHXaBnNv09oLVmV+0rSceqcupqqno8xlcpHMQsq9NthvsJA8SE8Hti1Y+Z+yvSq6J9klNpfV1bQbKOSYVMy1TRQWeYuvzhCkfTUeXNxz53WkyLK6f3mXLoOl71VtVT9CrkRXnuQzEKbXJHiHYm9wbYxajMOlPgACBBm5u6xEWA1GTJLrCJPhtNZSZWeKBJYHODdkA2vrMRPLapfHIUBy9zcgDubcX8u3niLzHT+T5rBFRZpllNViGJ44jPIXlVCu1rOfHyNoY3ub8381ssymiyeOSHK6GGBJXMjhXPie1rm478C/2/bOBCpqQw3rqNa+lekaeeEPa0kMhR1IIIII+scg3BFwQQSMNqbKYaQjoLOqgIoU10zKAnayk2H1+vnfEXNp3SmV6eky6rp6WmyT5tnSaudYEtKHWxY2W7m/Ft3AN+2J0wMYgnMZCT6Tns2pdX/G7LI5mBzOob0vnNOtLTUNKkkjrDGYw0jl3YAKLsx5J9Se+DCFZFRwZZlkGWiL3KKAJTGKUyKYgqhbMe4taxub98GNGj9nr7ob9oWHLP7QG0bHoUaer1ypMzfNmUUEm+SoaJYgWYjsqqbAW5dr38Ntqcgq6mvyLLa6sAFRU0kMsoC28bIC3HlyTjM0smwKE8Xm1/wD7jtjTHT38wZb+hw/5Bi/pTC2JMqLGtZOERN1IYMGDFVTUlFV5XQ6eq6rOlVqFH+eDQmUbTtHKAEkXI8vrxYAACbAc8n68QFPnGXZBkNTm2bVHQpIJR1JNjPbcVUcKCTyQO2JqnqY6nqdNZR0pGibqRPHcjuRuA3D0YXB8jjGrH6zhOzjr6bOabheGBxHlvGyRE+4nklsGEKishpXjSRJ2MhsOnA8gHIHJUEL9Id7cXPYG3MVfBNVyUSJUCSIbmZqaRYz+ZyoVu/YE4jCilBS0wd5BTxb5CpdtguxX6Nz528vTDDPpMgocpqajPaaBqFnQzq9N1g7l1VLoASx3bLcHsPTDyirYa+IzQJUKobbaankha/8AdcA2572thHMc6y3KcsbOMyqDTUibN0kkbDbvYKt1tccsByOPO2G0g41GgAkyLDPlnfZYpdYgU3EkAQbnLnlbbcKKr5qCoyzLJ8qCCikgD0wRNiiIqpSy2G0WtxYWwY7zWspsxosvzCjk6lPVRdaJ7EbkYKVNjyOCO+DGjRs2+/PPNDILRHTLksr/AHn+Se6dCG28ydTZ85cgC270Fjx28R+q2lunv5gy39Dh/wAgxmZjTPT38wZb+hw/5BjT0z/VAUhgwYMUV1T2RFloXKJuPWta9uLLc/YOcL5dV5lUzVyZhlPucdPULHSv11k95iMMbmSw+haR5I9p5PS3dmGKyQD3AODav4o+GKr9Gxkmc/m1dlW5pJw9lpty3tfeBxxz+9v1frwtil7V/FHwwbV/FHwxDwe/p+0SrphtJVzpO0S5ZUuqrcSq0e1ja9hdwb+XIGKptX8UfDBtX8UfDB4Pf0/aJUxnzM8dK7RtGWDEo1rqfDwbEi/5icGIkrGoujMSTexQDaNo4vc38W4344IFuLkxZpMwMDVyZWXeNZNM/wDDmVfoMH/bXBgw3tjJnP8ACGqSwYMGMNTRgwYMCEYMGDAhGDBgwIRgwYMCF//Z',
					'remetente': '554791060553@c.us',
					'api_id': 'false_554791060553@c.us_3EB06ECB75FB0640A07F',
					'api_chat_id': null,
					'contato_id': null,
					'protocolo_id': 15,
					'usuario_id': null,
					'lida': 0,
					'tipo': 'image',
					'midia_url': 'medias/554791060553@c.us/140081028918672.jpe',
					'dados_extras': '{"mime":"image/jpeg","size":132700,"caption":null}',
					'created_at': '2021-05-19T12:38:52.000Z',
					'updated_at': '2021-05-19T12:38:52.000Z'
				}
			},
			{
				'id': 14,
				'criado_em': null,
				'finalizado_em': null,
				'deletado': 0,
				'numero': '1952021PMRAP',
				'status': 'Atendendo',
				'contato_id': 10,
				'recado_id': null,
				'api_chat_id': null,
				'ultima_atualizacao': '2021-05-19T12:35:45.000Z',
				'usuario_id': 1,
				'abandonado': 0,
				'created_at': '2021-05-19T12:35:45.000Z',
				'updated_at': '2021-05-19T12:35:45.000Z',
				'contato': {
					'id': 10,
					'criado_em': null,
					'last_activity': null,
					'deletado': 0,
					'nome': 'Ricardo Vogelsanger',
					'avatar_arquivo': null,
					'avatar_url': '',
					'telefone': '5547991060553',
					'celular': '5547991060553',
					'whatsapp': '5547991060553',
					'valido': 1,
					'descricao': null,
					'empresa': null,
					'grupo_id': null,
					'inscrito': 1,
					'cidade_id': null,
					'sexo': 'Masculino',
					'usuario_id': null,
					'bloqueado': null,
					'origem': null,
					'operadora': null,
					'email': null,
					'whatsapp_status': null,
					'canal_id': 2,
					'created_at': '2021-05-19T12:35:45.000Z',
					'updated_at': '2021-05-19T12:35:45.000Z'
				},
				'mensagens_enviadas': [
					{
						'id': 41,
						'criado_em': null,
						'deletado': 0,
						'conteudo': null,
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '5547991060553',
						'enviado': 0,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 10,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 14,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'image',
						'midia_url': 'medias/sent/0883f735-4fa8-48d7-aecb-ab1742981498',
						'dados_extras': '{"mime":"image/jpeg","size":7240,"caption":""}',
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T12:37:51.000Z',
						'updated_at': '2021-05-19T12:37:51.000Z'
					}
				],
				'mensagens_recebidas': [],
				'unread_messages_count': 0,
				'mensagens': [
					{
						'id': 41,
						'criado_em': null,
						'deletado': 0,
						'conteudo': null,
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '5547991060553',
						'enviado': 0,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 10,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 14,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'image',
						'midia_url': 'medias/sent/0883f735-4fa8-48d7-aecb-ab1742981498',
						'dados_extras': '{"mime":"image/jpeg","size":7240,"caption":""}',
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T12:37:51.000Z',
						'updated_at': '2021-05-19T12:37:51.000Z'
					}
				],
				'last_message': {
					'id': 41,
					'criado_em': null,
					'deletado': 0,
					'conteudo': null,
					'conteudo_link': null,
					'conteudo_imagem_url': null,
					'conteudo_arquivo_url': null,
					'conteudo_audio_url': null,
					'conteudo_contato': null,
					'localizacao_latitude': null,
					'localizacao_longitude': null,
					'destinatario': '5547991060553',
					'enviado': 0,
					'respondida': 0,
					'encaminhada': 0,
					'campanha_id': null,
					'contato_id': 10,
					'api_id': '0',
					'api_chat_id': '0',
					'status': 'Desconhecido',
					'tentativas_envio': 0,
					'protocolo_id': 14,
					'usuario_id': 1,
					'instancia_id': null,
					'tipo': 'image',
					'midia_url': 'medias/sent/0883f735-4fa8-48d7-aecb-ab1742981498',
					'dados_extras': '{"mime":"image/jpeg","size":7240,"caption":""}',
					'em_resposta_enviada_id': null,
					'em_resposta_recebida_id': null,
					'created_at': '2021-05-19T12:37:51.000Z',
					'updated_at': '2021-05-19T12:37:51.000Z'
				}
			},
			{
				'id': 12,
				'criado_em': null,
				'finalizado_em': null,
				'deletado': 0,
				'numero': '1952021GRIV0',
				'status': 'Atendendo',
				'contato_id': 7,
				'recado_id': null,
				'api_chat_id': '555184997409@c.us',
				'ultima_atualizacao': '2021-05-19T12:34:05.000Z',
				'usuario_id': 1,
				'abandonado': 0,
				'created_at': '2021-05-19T12:34:05.000Z',
				'updated_at': '2021-05-19T12:34:16.000Z',
				'contato': {
					'id': 7,
					'criado_em': null,
					'last_activity': '2021-05-19T12:39:22.000Z',
					'deletado': 0,
					'nome': 'Eduardo Maciel',
					'avatar_arquivo': null,
					'avatar_url': '',
					'telefone': '555184997409',
					'celular': '555184997409',
					'whatsapp': '555184997409',
					'valido': 1,
					'descricao': null,
					'empresa': null,
					'grupo_id': null,
					'inscrito': 1,
					'cidade_id': null,
					'sexo': 'Masculino',
					'usuario_id': null,
					'bloqueado': null,
					'origem': null,
					'operadora': null,
					'email': null,
					'whatsapp_status': null,
					'canal_id': 2,
					'created_at': '2021-05-19T11:47:10.000Z',
					'updated_at': '2021-05-19T12:39:22.000Z'
				},
				'mensagens_enviadas': [
					{
						'id': 35,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Tudo certo?',
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '555184997409',
						'enviado': 1,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 7,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 12,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': null,
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T12:34:25.000Z',
						'updated_at': '2021-05-19T12:34:25.000Z'
					}
				],
				'mensagens_recebidas': [
					{
						'id': 49,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'BEGIN:VCARD\nVERSION:3.0\nN:Vogelsanger;Ricardo;;;\nFN:Ricardo Vogelsanger\nitem1.TEL;waid=554791060553:+55 47 9106-0553\nitem1.X-ABLabel:Celular\nEND:VCARD',
						'remetente': '555184997409@c.us',
						'api_id': 'false_555184997409@c.us_A33F5C3BD8CF0D0C6447C04EC50BE4E4',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 12,
						'usuario_id': null,
						'lida': 1,
						'tipo': 'vcard',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T12:39:22.000Z',
						'updated_at': '2021-05-19T12:40:03.000Z'
					}
				],
				'unread_messages_count': 0,
				'last_received_message': 'BEGIN:VCARD\nVERSION:3.0\nN:Vogelsanger;Ricardo;;;\nFN:Ricardo Vogelsanger\nitem1.TEL;waid=554791060553:+55 47 9106-0553\nitem1.X-ABLabel:Celular\nEND:VCARD',
				'mensagens': [
					{
						'id': 35,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Tudo certo?',
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '555184997409',
						'enviado': 1,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 7,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 12,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': null,
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T12:34:25.000Z',
						'updated_at': '2021-05-19T12:34:25.000Z'
					},
					{
						'id': 49,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'BEGIN:VCARD\nVERSION:3.0\nN:Vogelsanger;Ricardo;;;\nFN:Ricardo Vogelsanger\nitem1.TEL;waid=554791060553:+55 47 9106-0553\nitem1.X-ABLabel:Celular\nEND:VCARD',
						'remetente': '555184997409@c.us',
						'api_id': 'false_555184997409@c.us_A33F5C3BD8CF0D0C6447C04EC50BE4E4',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 12,
						'usuario_id': null,
						'lida': 1,
						'tipo': 'vcard',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T12:39:22.000Z',
						'updated_at': '2021-05-19T12:40:03.000Z'
					}
				],
				'last_message': {
					'id': 49,
					'criado_em': null,
					'deletado': 0,
					'conteudo': 'BEGIN:VCARD\nVERSION:3.0\nN:Vogelsanger;Ricardo;;;\nFN:Ricardo Vogelsanger\nitem1.TEL;waid=554791060553:+55 47 9106-0553\nitem1.X-ABLabel:Celular\nEND:VCARD',
					'remetente': '555184997409@c.us',
					'api_id': 'false_555184997409@c.us_A33F5C3BD8CF0D0C6447C04EC50BE4E4',
					'api_chat_id': null,
					'contato_id': null,
					'protocolo_id': 12,
					'usuario_id': null,
					'lida': 1,
					'tipo': 'vcard',
					'midia_url': null,
					'dados_extras': 'null',
					'created_at': '2021-05-19T12:39:22.000Z',
					'updated_at': '2021-05-19T12:40:03.000Z'
				}
			},
			{
				'id': 9,
				'criado_em': null,
				'finalizado_em': '2021-05-19T11:54:00.000Z',
				'deletado': 0,
				'numero': '1952021GFFY1',
				'status': 'Concluido',
				'contato_id': 7,
				'recado_id': null,
				'api_chat_id': '555184997409@c.us',
				'ultima_atualizacao': '2021-05-19T11:49:25.000Z',
				'usuario_id': 1,
				'abandonado': 0,
				'created_at': '2021-05-19T11:49:25.000Z',
				'updated_at': '2021-05-19T11:54:00.000Z',
				'contato': {
					'id': 7,
					'criado_em': null,
					'last_activity': '2021-05-19T12:39:22.000Z',
					'deletado': 0,
					'nome': 'Eduardo Maciel',
					'avatar_arquivo': null,
					'avatar_url': '',
					'telefone': '555184997409',
					'celular': '555184997409',
					'whatsapp': '555184997409',
					'valido': 1,
					'descricao': null,
					'empresa': null,
					'grupo_id': null,
					'inscrito': 1,
					'cidade_id': null,
					'sexo': 'Masculino',
					'usuario_id': null,
					'bloqueado': null,
					'origem': null,
					'operadora': null,
					'email': null,
					'whatsapp_status': null,
					'canal_id': 2,
					'created_at': '2021-05-19T11:47:10.000Z',
					'updated_at': '2021-05-19T12:39:22.000Z'
				},
				'mensagens_enviadas': [
					{
						'id': 32,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'oi',
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '555184997409',
						'enviado': 1,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 7,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 9,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': null,
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T11:53:40.000Z',
						'updated_at': '2021-05-19T11:53:40.000Z'
					}
				],
				'mensagens_recebidas': [
					{
						'id': 34,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Show!',
						'remetente': '555184997409@c.us',
						'api_id': 'false_555184997409@c.us_D2609F5FE959F4A2FB5DEC05AFC8004B',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 9,
						'usuario_id': null,
						'lida': 0,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T11:53:57.000Z',
						'updated_at': '2021-05-19T11:53:57.000Z'
					}
				],
				'unread_messages_count': 1,
				'last_received_message': 'Show!',
				'mensagens': [
					{
						'id': 32,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'oi',
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '555184997409',
						'enviado': 1,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 7,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 9,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': null,
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T11:53:40.000Z',
						'updated_at': '2021-05-19T11:53:40.000Z'
					},
					{
						'id': 34,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Show!',
						'remetente': '555184997409@c.us',
						'api_id': 'false_555184997409@c.us_D2609F5FE959F4A2FB5DEC05AFC8004B',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 9,
						'usuario_id': null,
						'lida': 0,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T11:53:57.000Z',
						'updated_at': '2021-05-19T11:53:57.000Z'
					}
				],
				'last_message': {
					'id': 34,
					'criado_em': null,
					'deletado': 0,
					'conteudo': 'Show!',
					'remetente': '555184997409@c.us',
					'api_id': 'false_555184997409@c.us_D2609F5FE959F4A2FB5DEC05AFC8004B',
					'api_chat_id': null,
					'contato_id': null,
					'protocolo_id': 9,
					'usuario_id': null,
					'lida': 0,
					'tipo': 'chat',
					'midia_url': null,
					'dados_extras': 'null',
					'created_at': '2021-05-19T11:53:57.000Z',
					'updated_at': '2021-05-19T11:53:57.000Z'
				}
			},
			{
				'id': 7,
				'criado_em': null,
				'finalizado_em': '2021-05-19T11:49:08.000Z',
				'deletado': 0,
				'numero': '1952021ASLGO',
				'status': 'Concluido',
				'contato_id': 7,
				'recado_id': null,
				'api_chat_id': '555184997409@c.us',
				'ultima_atualizacao': '2021-05-19T11:47:10.000Z',
				'usuario_id': 1,
				'abandonado': 0,
				'created_at': '2021-05-19T11:47:10.000Z',
				'updated_at': '2021-05-19T11:49:08.000Z',
				'contato': {
					'id': 7,
					'criado_em': null,
					'last_activity': '2021-05-19T12:39:22.000Z',
					'deletado': 0,
					'nome': 'Eduardo Maciel',
					'avatar_arquivo': null,
					'avatar_url': '',
					'telefone': '555184997409',
					'celular': '555184997409',
					'whatsapp': '555184997409',
					'valido': 1,
					'descricao': null,
					'empresa': null,
					'grupo_id': null,
					'inscrito': 1,
					'cidade_id': null,
					'sexo': 'Masculino',
					'usuario_id': null,
					'bloqueado': null,
					'origem': null,
					'operadora': null,
					'email': null,
					'whatsapp_status': null,
					'canal_id': 2,
					'created_at': '2021-05-19T11:47:10.000Z',
					'updated_at': '2021-05-19T12:39:22.000Z'
				},
				'mensagens_enviadas': [
					{
						'id': 28,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'oi',
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '555184997409',
						'enviado': 1,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 7,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 7,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': null,
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T11:48:41.000Z',
						'updated_at': '2021-05-19T11:48:41.000Z'
					}
				],
				'mensagens_recebidas': [
					{
						'id': 21,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Show!',
						'remetente': '555184997409@c.us',
						'api_id': 'false_555184997409@c.us_CCAC79BD9FFBBD835B63434C7428A96F',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 7,
						'usuario_id': null,
						'lida': 1,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T11:48:58.000Z',
						'updated_at': '2021-05-19T11:49:03.000Z'
					}
				],
				'unread_messages_count': 0,
				'last_received_message': 'Show!',
				'mensagens': [
					{
						'id': 28,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'oi',
						'conteudo_link': null,
						'conteudo_imagem_url': null,
						'conteudo_arquivo_url': null,
						'conteudo_audio_url': null,
						'conteudo_contato': null,
						'localizacao_latitude': null,
						'localizacao_longitude': null,
						'destinatario': '555184997409',
						'enviado': 1,
						'respondida': 0,
						'encaminhada': 0,
						'campanha_id': null,
						'contato_id': 7,
						'api_id': '0',
						'api_chat_id': '0',
						'status': 'Desconhecido',
						'tentativas_envio': 0,
						'protocolo_id': 7,
						'usuario_id': 1,
						'instancia_id': null,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': null,
						'em_resposta_enviada_id': null,
						'em_resposta_recebida_id': null,
						'created_at': '2021-05-19T11:48:41.000Z',
						'updated_at': '2021-05-19T11:48:41.000Z'
					},
					{
						'id': 21,
						'criado_em': null,
						'deletado': 0,
						'conteudo': 'Show!',
						'remetente': '555184997409@c.us',
						'api_id': 'false_555184997409@c.us_CCAC79BD9FFBBD835B63434C7428A96F',
						'api_chat_id': null,
						'contato_id': null,
						'protocolo_id': 7,
						'usuario_id': null,
						'lida': 1,
						'tipo': 'chat',
						'midia_url': null,
						'dados_extras': 'null',
						'created_at': '2021-05-19T11:48:58.000Z',
						'updated_at': '2021-05-19T11:49:03.000Z'
					}
				],
				'last_message': {
					'id': 21,
					'criado_em': null,
					'deletado': 0,
					'conteudo': 'Show!',
					'remetente': '555184997409@c.us',
					'api_id': 'false_555184997409@c.us_CCAC79BD9FFBBD835B63434C7428A96F',
					'api_chat_id': null,
					'contato_id': null,
					'protocolo_id': 7,
					'usuario_id': null,
					'lida': 1,
					'tipo': 'chat',
					'midia_url': null,
					'dados_extras': 'null',
					'created_at': '2021-05-19T11:48:58.000Z',
					'updated_at': '2021-05-19T11:49:03.000Z'
				}
			}
		];

		this.contactListService.add([
			{
				"id": 7,
				"criado_em": null,
				"last_activity": "2021-05-19T12:39:22.000Z",
				"deletado": 0,
				"nome": "Eduardo Maciel",
				"avatar_arquivo": null,
				"avatar_url": "",
				"telefone": "555184997409",
				"celular": "555184997409",
				"whatsapp": "555184997409",
				"valido": 1,
				"descricao": null,
				"empresa": null,
				"grupo_id": null,
				"inscrito": 1,
				"cidade_id": null,
				"sexo": "Masculino",
				"usuario_id": null,
				"bloqueado": null,
				"origem": null,
				"operadora": null,
				"email": null,
				"whatsapp_status": null,
				"canal_id": 2,
				"created_at": "2021-05-19T11:47:10.000Z",
				"updated_at": "2021-05-19T12:39:22.000Z",
				"forward_message": false
			},
			{
				"id": 10,
				"criado_em": null,
				"last_activity": null,
				"deletado": 0,
				"nome": "Ricardo Vogelsanger",
				"avatar_arquivo": null,
				"avatar_url": "",
				"telefone": "5547991060553",
				"celular": "5547991060553",
				"whatsapp": "5547991060553",
				"valido": 1,
				"descricao": null,
				"empresa": null,
				"grupo_id": null,
				"inscrito": 1,
				"cidade_id": null,
				"sexo": "Masculino",
				"usuario_id": null,
				"bloqueado": null,
				"origem": null,
				"operadora": null,
				"email": null,
				"whatsapp_status": null,
				"canal_id": 2,
				"created_at": "2021-05-19T12:35:45.000Z",
				"updated_at": "2021-05-19T12:35:45.000Z",
				"forward_message": false
			},
			{
				"id": 12,
				"criado_em": null,
				"last_activity": "2021-05-19T12:38:52.000Z",
				"deletado": 0,
				"nome": "Ricardo",
				"avatar_arquivo": null,
				"avatar_url": "",
				"telefone": "554791060553",
				"celular": "554791060553",
				"whatsapp": "554791060553",
				"valido": 1,
				"descricao": null,
				"empresa": null,
				"grupo_id": null,
				"inscrito": 1,
				"cidade_id": null,
				"sexo": "Masculino",
				"usuario_id": null,
				"bloqueado": null,
				"origem": null,
				"operadora": null,
				"email": null,
				"whatsapp_status": null,
				"canal_id": 2,
				"created_at": "2021-05-19T12:38:10.000Z",
				"updated_at": "2021-05-19T12:38:52.000Z",
				"forward_message": false
			},
			{
				"id": 14,
				"criado_em": null,
				"last_activity": "2021-05-19T15:35:49.000Z",
				"deletado": 0,
				"nome": "+55 47 9781-8915",
				"avatar_arquivo": null,
				"avatar_url": "",
				"telefone": "554797818915",
				"celular": "554797818915",
				"whatsapp": "554797818915",
				"valido": 1,
				"descricao": null,
				"empresa": null,
				"grupo_id": null,
				"inscrito": 1,
				"cidade_id": null,
				"sexo": "Masculino",
				"usuario_id": null,
				"bloqueado": null,
				"origem": null,
				"operadora": null,
				"email": null,
				"whatsapp_status": null,
				"canal_id": 2,
				"created_at": "2021-05-19T15:32:21.000Z",
				"updated_at": "2021-05-19T15:35:49.000Z",
				"forward_message": false
			}
		]);
		this.protocolListService.add(protocolsData);

		this.contactListService.select(7);

		this.protocolListService.setActives([protocolsData[0]]);
		this.protocolListService.select(16);

		// this.socket = io.connect(constants.SOCKET);
		//
		// this.socket.on('disconnect', (e) => {
		// 	console.log('disconnect', e);
		// 	this.socket.connect();
		// 	// this.router.navigateByUrl('/disconnected');
		// });
		//
		// this.socket.on('connect', (e) => {
		// 	console.log('connected', e);
		// 	this.registerUser();
		// 	// 		this.events.publish('socket:chat:connect');
		// });
		// //
		// this.socket.on('open-protocols', data => {
		// 	// console.debug('open-protocols', data);
		//
		// 	// this.events.publish('socket:chat:receiveMessage', data);
		// 	// this.global.protocolos = data;
		//
		// 	// data.sort((a, b) => {
		// 	// 	return a.created_at < b.created_at ? -1 : 1;
		// 	// });
		//
		// 	this.ktDialogService.show();
		// 	this.protocolListService.add(data);
		// 	this.ktDialogService.hide();
		// 	// runStoreAction('protocol-list', StoreActions.SetEntities, {payload: data});
		// });
		//
		// this.socket.on('contacts', data => {
		// 	// console.debug('contacts', data);
		//
		// 	// data.sort((a, b) => {
		// 	// 	// return a.nome.localeCompare(b.nome);
		// 	// 	if ((!a.last_activity && b.last_activity) || a.last_activity < b.last_activity) {
		// 	// 		return 1;
		// 	// 	}
		// 	//
		// 	// 	if ((a.last_activity && !b.last_activity) || a.last_activity > b.last_activity) {
		// 	// 		return -1;
		// 	// 	}
		// 	//
		// 	// 	return 0;
		// 	// });
		//
		// 	this.ktDialogService.show();
		// 	this.contactListService.add(data);
		// 	this.ktDialogService.hide();
		// });
		//
		// this.socket.on('open-protocol', data => {
		// 	console.debug('open-protocol', data);
		//
		// 	if (!data) {
		// 		this.loading = false;
		// 		this.protocolListService.setActives([]);
		// 		return;
		// 	}
		//
		// 	// this.events.publish('socket:chat:receiveMessage', data);
		// 	data.mensagens = [...data.mensagens_enviadas, ...data.mensagens_recebidas];
		// 	data.mensagens.sort((a, b) => {
		// 		return a.timestamp < b.timestamp ? -1 : 1;
		// 	});
		//
		// 	if (data.protocolos_encaminhados) {
		// 		data.protocolos_encaminhados.sort((a, b) => {
		// 			return a.created_at < b.created_at ? -1 : 1;
		// 		});
		// 	}
		// 	// this.global.protocolo_ativo = data;
		//
		// 	this.protocolListService.add(data);
		// 	this.protocolListService.setActives([data]);
		// 	this.protocolListService.select(data.id);
		// 	this.loading = false;
		//
		// 	const that = this;
		// 	setTimeout(() => {
		// 		that.tools.scrollToBottom();
		// 	}, 500);
		//
		// });
		//
		// this.socket.on('new-protocol', data => {
		// 	console.debug('new-protocol', data);
		//
		// 	this.protocolListService.add(data);
		//
		// 	if (data.usuario_id === this.user.getUser().id) {
		// 		this.protocolListService.setActives([data]);
		// 		this.protocolListService.select(data.id);
		// 		this.socket.emit('open-protocol', {token: this.user.getToken(), protocol_id: data.id});
		// 	} else {
		// 		this.audio.playNotification();
		// 	}
		//
		// 	let notificationData: Array<any> = [];
		// 	notificationData.push({
		// 		'title': 'Novo Protocolo',
		// 		'alertContent': data.numero,
		// 		'icon': 'assets/media/logos/logo.png'
		// 	});
		// 	this.notification.generateNotification(notificationData);
		// 	// this.global.protocolos.push(data);
		// });
		//
		// this.socket.on('new-contact', data => {
		// 	console.debug('new-contact', data);
		//
		// 	this.contactListService.add(data);
		// });
		//
		// this.socket.on('close-protocol', data => {
		// 	console.debug('close-protocol', data);
		//
		// 	// this.protocolListService.update(data.id, data);
		// 	this.protocolListService.remove(data.id);
		// 	// this.global.protocolos.push(data);
		// });
		//
		// this.socket.on('update-protocol', data => {
		// 	console.debug('update-protocol', data);
		// 	this.protocolListService.update(data.id, data);
		// });
		//
		// this.socket.on('protocol-message', async data => {
		// 	console.debug('protocol-message', data);
		//
		// 	// const dataProtocol = data.protocolo.protocolo ? data.protocolo.protocolo : data.protocolo;
		//
		// 	// if (this.global.protocolo_ativo.id === data.protocolo.id) {
		// 	// 	this.global.protocolo_ativo.mensagens.push(data.mensagem);
		// 	// }
		//
		// 	this.protocolListService.addMessage(data.protocolo.id, data.mensagem);
		//
		// 	// const protocol = await this.protocolListService.get(dataProtocol.id);
		//
		// 	this.contactListService.updateContactLastActivity(data.protocolo.contato_id);
		//
		// 	(this.protocolListQuery.selectActive() as any).pipe(take(1)).subscribe(value => {
		// 		if (value && value.id != data.protocolo.id) {
		// 			if (data.mensagem.remetente) {
		// 				let notificationData: Array<any> = [];
		// 				notificationData.push({
		// 					'title': data.protocolo.contato ? data.protocolo.contato.nome : 'Nova Mensagem',
		// 					'alertContent': this.tools.getMessageHtmlContent(data.mensagem),
		// 					'icon': data.protocolo.contato ? data.protocolo.contato.avatar_url : './assets/media/users/default.jpg'
		// 				});
		// 				this.notification.generateNotification(notificationData);
		// 			}
		// 		}
		// 	});
		//
		// 	// const that = this;
		// 	// setTimeout(() => {
		// 	// 	that.tools.scrollToBottom();
		// 	// }, 250);
		//
		// 	// this.global.protocolos.push(data);
		// });
		//
		// this.socket.on('protocol-messages', data => {
		// 	console.debug('protocol-messages', data);
		//
		// 	this.protocolListService.addMessages(data.id, [...data.mensagens_enviadas, ...data.mensagens_recebidas]);
		//
		// 	this.loading = false;
		// });
		//
		// this.socket.on('contact-protocols', data => {
		// 	console.debug('contact-protocols', data);
		//
		// 	this.protocolListService.add(data);
		// 	this.protocolListService.setActives(data);
		//
		// 	this.loading = false;
		// });
		//
		// this.socket.on('update-protocol-message', data => {
		// 	console.debug('update-protocol-message', data);
		//
		// 	this.protocolListService.updateMessage(data.protocolo.id, data.mensagem);
		// });
		//
		// // this.socket.on('contact-protocols', data => {
		// // 	console.debug('contact-protocols', data);
		// //
		// // 	// this.protocolListService.update(data.protocolo.id, data.mensagem);
		// // });
		//
		// this.socket.on('contact-advanced-search', data => {
		// 	console.debug('contact-advanced-search', data);
		//
		// 	// this.protocolListService.update(data.protocolo.id, data.mensagem);
		// });
	}

	//
	public registerUser() {
		// if (this.user.getToken()) {
		// 	this.socket.emit('register', this.user.getToken());
		// }
	}

	//
	// public registerProvider() {
	// 	this.socket.emit('register-provider', this.user.getToken());
	// }
	sendMessage(message: string, protocolId: any, contactId: any) {
		// this.socket.emit('message', {token: this.user.getToken(), body: message, protocol_id: protocolId});
		// this.contactListService.updateContactLastActivity(contactId);
		// this.tools.scrollToBottom();
	}

	openProtocol(protocol: any) {
		// this.loading = true;
		//
		// this.contactListService.select(protocol.contato_id);
		// this.protocolListService.select(protocol.id);
		// this.socket.emit('open-protocol', {token: this.user.getToken(), protocol_id: protocol.id});
	}

	sendImage(image: any, caption: string, protocolId: any) {
		// this.socket.emit('image', {
		// 	token: this.user.getToken(),
		// 	body: image,
		// 	caption: caption || '',
		// 	filename: 'todo',
		// 	protocol_id: protocolId
		// });
	}

	sendFile(image: any, caption: string, protocolId: any) {
		// this.socket.emit('file', {
		// 	token: this.user.getToken(),
		// 	body: image,
		// 	caption: caption,
		// 	filename: caption,
		// 	protocol_id: protocolId
		// });
	}

	closeProtocol(protocol: any, message, send_message) {
		// this.protocolListService.select(null);
		// this.contactListService.select(null);
		// this.socket.emit('close-protocol', {token: this.user.getToken(), protocol_id: protocol.id, message, send_message});
	}

	replyMessage(replyingMessage: any, message: any, protocolId: any) {
		// if (message.remetente) {
		// 	this.socket.emit('reply-message', {
		// 		token: this.user.getToken(),
		// 		body: message,
		// 		protocol_id: protocolId,
		// 		message_id: replyingMessage.api_id,
		// 		em_resposta_recebida_id: replyingMessage.id
		// 	});
		// } else {
		// 	this.socket.emit('reply-message', {
		// 		token: this.user.getToken(),
		// 		body: message,
		// 		protocol_id: protocolId,
		// 		message_id: replyingMessage.api_id,
		// 		em_resposta_enviada_id: replyingMessage.id
		// 	});
		// }
	}

	sendAudio(audio: any, protocolId: any) {
		// this.socket.emit('audio', {token: this.user.getToken(), body: audio, filename: 'Mensagem de Voz', protocol_id: protocolId});
	}

	sendLocation(data, protocolId) {
		// this.socket.emit('location', {token: this.user.getToken(), body: data, protocol_id: protocolId});
	}

	sendContact(whatsapp, protocolId) {
		// this.socket.emit('contact', {token: this.user.getToken(), body: (whatsapp + '@c.us'), protocol_id: protocolId});
	}

	getProtocolMessages(page, protocolId) {
		// this.loading = true;
		//
		// this.socket.emit('get-protocol-messages', {token: this.user.getToken(), page, protocol_id: protocolId});
	}

	getContactProtocols(contact_id) {
		// this.loading = true;
		//
		// this.socket.emit('get-contact-protocols', {token: this.user.getToken(), contact_id});
	}

	// doContactAdvancedSearch(contact_id, protocol_id, message) {
	// 	this.socket.emit('do-contact-advanced-search', {token: this.user.getToken(), contact_id, protocol_id, message});
	// }

	setUserStatus(status) {
		// this.socket.emit('set-user-status', {token: this.user.getToken(), status});
	}

	sendActiveCommunication(data) {
		// this.socket.emit('active-communication', {token: this.user.getToken(), data});
	}

	forwardMessage(message: any, whatsapp_id: any, contact_id) {
		// this.socket.emit('forward-message', {
		// 	token: this.user.getToken(),
		// 	message_id: message.api_id,
		// 	whatsapp_id,
		// 	contact_id
		// });
	}

	saveProfilePicture(imageData) {
		// this.socket.emit('set-user-picture', {token: this.user.getToken(), picture: imageData});
	}

	openContact(contact: any) {
		// this.loading = true;
		//
		// this.contactListService.select(contact.id);
		// this.socket.emit('open-contact', {token: this.user.getToken(), contact_id: contact.id});
	}

	openNewProtocol(contato_id: any) {
		// this.loading = true;
		//
		// this.socket.emit('open-new-protocol', {token: this.user.getToken(), contact_id: contato_id});
	}

	saveContactName(contact_id, name) {
		// this.socket.emit('save-contact-name', {token: this.user.getToken(), contact_id, name});
	}

	addContact(name, phone) {
		// this.socket.emit('add-contact', {token: this.user.getToken(), name, phone});
	}

	attendProtocol(protocol: any) {
		// console.log(protocol);
		//
		// this.loading = true;
		//
		// this.contactListService.select(protocol.contato_id);
		// this.protocolListService.select(protocol.id);
		// this.socket.emit('attend-protocol', {token: this.user.getToken(), protocol_id: protocol.id});
	}
}
